// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.license-manage-container {
    width: 60%;
    margin-left: auto;
    margin-right: auto;
}

.license-manage-container_license-lable {
    text-align: left;
    margin-bottom: 1rem;
    font-weight: 600;
}

.license-manage-container_license {
    width: 100%;
    height: 30rem;
}

.license-manage-header {
    font-size: 4rem;
    font-weight: 600;
    text-align: center;
}

.license-manage-save {
    float: right;
    margin-right: 5rem;
    margin-top: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/app/license/license-manage/LicenseManage.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;AACpB","sourcesContent":[".license-manage-container {\r\n    width: 60%;\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n}\r\n\r\n.license-manage-container_license-lable {\r\n    text-align: left;\r\n    margin-bottom: 1rem;\r\n    font-weight: 600;\r\n}\r\n\r\n.license-manage-container_license {\r\n    width: 100%;\r\n    height: 30rem;\r\n}\r\n\r\n.license-manage-header {\r\n    font-size: 4rem;\r\n    font-weight: 600;\r\n    text-align: center;\r\n}\r\n\r\n.license-manage-save {\r\n    float: right;\r\n    margin-right: 5rem;\r\n    margin-top: 1rem;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
